__turbopack_context__.v({
  "bodyTypeFilter": "BodyTypeFilter-module__dg4A1W__bodyTypeFilter",
  "icon": "BodyTypeFilter-module__dg4A1W__icon",
  "listItem": "BodyTypeFilter-module__dg4A1W__listItem",
});
